import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchPage } from '../services/api/pages';

export const usePage = (pageId?: string) => {
  return useQuery({
    queryKey: ['page', pageId],
    queryFn: () => fetchPage(pageId!),
    enabled: Boolean(pageId),
    placeholderData: keepPreviousData,
  });
};
